import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewContainerRef, forwardRef } from '@angular/core';
import { PopupComponent } from "sharedFeatures/window";
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { MinValuePipe } from '../../../../pipes/minvalue.pipe';
import { SafeHtmlPipe } from '../../../../pipes/safehtml.pipe';
import { infoPopUpComponent } from '../../infoPopUp/infoPopUp.component';
import { NewPlanFormBodyComponent } from '../newplan-body.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'create-plan-loader-popup',
    templateUrl: './create-plan-loader-popup.component.html',
    styleUrls: ['./create-plan-loader-popup.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, infoPopUpComponent, MinValuePipe, SafeHtmlPipe, forwardRef(() => NewPlanFormBodyComponent), TranslateModule],
})
export class CreatePlanLoaderPopup extends PopupComponent {

    modal = true;

    width = 600;

    height = 335;

    dimBackgroundCls = 'g2Background-important';

    dimOpacity: number = 1;

    backgroundFill = 'white-background';

    shadowStyle = 'create-plan-loader-shadow';

    cornerRadius = 6;


    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef
    ) {

        super(element, r, viewContainerRef, chDet);

    }
    
}